import React from 'react';
import { useSearchParams } from '../../../../../play-core/hooks/use-search-params';
import { times } from '../../../../../play-core/utils/times';
import { loadVideosByShowId } from '../../../api/load-videos-by-show-id';
import { GridView } from '../../../components/GridView/GridView';
import { LoadMore } from '../../../components/LoadMore/LoadMore';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { GridMediaTeaser } from '../../../components/Teaser/MediaTeaser/GridMediaTeaser';
import { MediaTeaserPlaceholder } from '../../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { queryKeys } from '../../../config/use-query';
import { useAxios } from '../../../hooks/use-axios';
import { usePaging } from '../../../hooks/use-paging';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AvailableEpisodes = () => {
  const axios = useAxios();
  const {
    id: showId = ''
  } = useSearchParams();
  const {
    data: medias,
    isLoading,
    loadMore,
    canLoadMore
  } = usePaging(queryKeys.VideosByShowId(showId), next => loadVideosByShowId(axios, showId || '', next), {
    enabled: showId !== ''
  });
  const showLoadMore = canLoadMore && loadMore && !isLoading;
  return /*#__PURE__*/_jsxs(PlayContainer, {
    children: [/*#__PURE__*/_jsx(GridView, {
      children: isLoading && medias.length === 0 ? times(20, index => /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {}, index)) : medias?.map((media, index) => /*#__PURE__*/_jsx(GridMediaTeaser, {
        media: media,
        index: index
      }, media.id))
    }), showLoadMore && /*#__PURE__*/_jsx(LoadMore, {
      onClick: () => loadMore()
    })]
  });
};